import React from "react";
import Leads from "../features/leads";

const Home = () => {
  return <Leads />;
};

export default Home;
